import React from "react";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Collapse from "@mui/material/Collapse";
import Box from "@mui/material/Box";

function CollapsibleRow({ row, idx }) {
  const [open, setOpen] = React.useState(false);
  return (
    <>
      <TableRow 
        key={idx} 
        sx={{ 
          backgroundColor: idx % 2 === 0 ? "inherit" : "inherit", 
          "& > td": { borderBottom: "1px solid #f5f5f5" } // apply border on each cell
        }}
      >
        <TableCell>
          <span style={{ fontSize: "16px" }}>
            {row.name}
          </span>
        </TableCell>
        <TableCell align="right">
          <span style={{ fontSize: "16px" }}>
            {row.value}
          </span>
        </TableCell>
        <TableCell sx={{ width: "5%", p: 0 }} align="right">
          <Box
            component="span"
            onClick={() => setOpen(!open)}
            sx={{
              cursor: "pointer",
              display: "flex",
              alignItems: "center",
              "&:hover": {
                "strong": { color: "primary.main" },
                "& span": { color: "primary.main", opacity: 1 }
              }
            }}
          >
            <Box
              component="span"
              sx={{
                marginLeft: 1,
                color: "#19284F",
                opacity: 0.5,
                transition: "color 0.3s, opacity 0.3s",
                fontSize: "16px"
              }}
            >
              (?)
            </Box>
          </Box>
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell colSpan={3} style={{ paddingBottom: 0, paddingTop: 0 }}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <div style={{ margin: "10px 0", paddingTop: "10px", paddingBottom: "10px" }}>
              {row.explanation}
            </div>
          </Collapse>
        </TableCell>
      </TableRow>
    </>
  );
}

const TableDisplay = ({ data }) => {
  return (
    <TableContainer>
      <Table sx={{ tableLayout: 'fixed' }}>
        <TableHead>
          <TableRow>
            <TableCell>
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>Description</span>
            </TableCell>
            <TableCell align="right">
              <span style={{ fontSize: "16px", fontWeight: "bold" }}>Value</span>
            </TableCell>
            <TableCell sx={{ width: "5%", p: 0 }} align="right">
              {/* Empty header for tooltip column */}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((row, idx) => (
            <CollapsibleRow row={row} idx={idx} key={idx} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TableDisplay;
